
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/styles-selection",
      function () {
        return require("private-next-pages/styles-selection/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/styles-selection"])
      });
    }
  